const VISITOR_SESSION_COOKIE = "_gs_sid";
const VISITOR_SESSION_MAX_AGE_SECONDS = 60 * 60 * 24 * 30; // 30 days

const generateVisitorSessionId = (): string => {
  if (typeof crypto !== "undefined" && "randomUUID" in crypto) {
    return crypto.randomUUID();
  }
  return `gs_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
};

const readCookie = (name: string): string | undefined => {
  if (typeof document === "undefined") return undefined;

  const prefix = `${name}=`;
  const match = document.cookie
    .split(";")
    .map((part) => part.trim())
    .find((part) => part.startsWith(prefix));

  if (!match) return undefined;

  try {
    return decodeURIComponent(match.slice(prefix.length));
  } catch {
    return match.slice(prefix.length);
  }
};

const writeCookie = (name: string, value: string): void => {
  if (typeof document === "undefined") return;

  const secure =
    typeof window !== "undefined" && window.location.protocol === "https:"
      ? "; Secure"
      : "";

  document.cookie = `${name}=${encodeURIComponent(value)}; Max-Age=${VISITOR_SESSION_MAX_AGE_SECONDS}; Path=/; SameSite=Lax${secure}`;
};

export const getVisitorSessionId = (): string => {
  if (typeof window === "undefined") return "";

  const existing = readCookie(VISITOR_SESSION_COOKIE);
  if (existing) return existing;

  const nextId = generateVisitorSessionId();
  writeCookie(VISITOR_SESSION_COOKIE, nextId);
  return nextId;
};

export const ensureVisitorSessionId = (): string => {
  const visitorSessionId = getVisitorSessionId();

  if (typeof window !== "undefined" && visitorSessionId) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "visitor_session_initialized",
      visitor_session_id: visitorSessionId,
    });
  }

  return visitorSessionId;
};
